// extracted by mini-css-extract-plugin
export default {"container":"player-spotlights-overlay_container__ESwGa"};